// @flow
import React from 'react';
import Link from 'Components/Link';
import Icon from 'Components/Icon';
import { Row } from 'Components/Grid';
import DealerModel from 'Stores/DealerModel';
import DealerSettingsModel from 'Stores/DealerSettingsModel';
import styles from './styles.scss';
import { footerTracking } from 'Utils/trackingAttributes';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

type Props = {
  dealer: DealerModel,
};

export default class SocialMedia extends React.Component<Props> {
  renderSocialMediaLink(link: Object) {
    const formatedName = link.key.charAt(0).toUpperCase() + link.key.slice(1);

    return (
      <Link
        className={cx(
          styles.link,
          ['twitter', 'linkedin', 'tiktok'].includes(link.key) && styles.sizeCorrection
        )}
        key={link.key}
        to={link.href}
        target="_blank"
        rel="noopener noreferrer"
        title={formatedName}
        additionalProps={footerTracking(link.key)}
        ariaLabel={`Soziales Netzwerk ${formatedName}`}
      >
        <Icon name={`social-${link.key}`} inline={false} />
      </Link>
    );
  }

  render() {
    const settings: DealerSettingsModel = this.props.dealer.settings;
    const links = settings.getSocialMediaLinks();

    return (
      <div className={styles.root}>
        <Row>
          <div className={styles.wrapper}>
            {
              <div className={styles.vacancies}>
                <Link
                  to="/ueber-uns/autohaus/karriere"
                  label="Stellenanzeigen"
                  ariaLabel="Stellenanzeigen"
                  {...footerTracking('Stellenanzeigen')}
                />
              </div>
            }
            {links.length > 0 && (
              <div className={styles.links}>
                {links.map((link) => this.renderSocialMediaLink(link))}
              </div>
            )}
          </div>
        </Row>
      </div>
    );
  }
}
